/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_SubscriptionInputs */

const en_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Subscription`)
};

const fr_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer l'abonnement`)
};

const de_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement verwalten`)
};

const it_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci abbonamento`)
};

const ru_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление подпиской`)
};

const es_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar suscripción`)
};

const zh_cn2_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理订阅`)
};

const ja_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションの管理`)
};

const hi_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता प्रबंधित करें`)
};

const pt_pt2_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar assinatura`)
};

/**
* | output |
* | --- |
* | "Manage Subscription" |
*
* @param {Manage_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manage_subscription = /** @type {((inputs?: Manage_SubscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_SubscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manage_subscription(inputs)
	if (locale === "de") return de_manage_subscription(inputs)
	if (locale === "it") return it_manage_subscription(inputs)
	if (locale === "ru") return ru_manage_subscription(inputs)
	if (locale === "es") return es_manage_subscription(inputs)
	if (locale === "zh-CN") return zh_cn2_manage_subscription(inputs)
	if (locale === "ja") return ja_manage_subscription(inputs)
	if (locale === "hi") return hi_manage_subscription(inputs)
	if (locale === "pt-PT") return pt_pt2_manage_subscription(inputs)
	return en_manage_subscription(inputs)
});